module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-06.58cd8de2.svg";